import gradeType from "./gradeType";
    
    export const successFetchedGrade =(data)=>({
        type: gradeType.SUCCESS_FETCHIED_GRADE,
        payload: data
         })
        export const failureFetchedGrade =(data)=>({
        type: gradeType.FAILURE_FETCHED_GRADE,
        errorMessage: data
         })